import { NotesService } from '../../../BaseFramework/core/http/notes.service';
import { HttpRequest, HttpClient, HttpEventType, HttpEvent, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { environment } from 'environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ClientService,
  AppConfig,
  ComponentOutputDO,
  AppMetadataHandler
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';
import { DataTransformService } from 'app/ViewModules/shared-services';

interface correspondenceDO {
  id: any,
  entityGuid: any;
  templateCd: any;
  overRideFl: any;
  receipent: any;
  cc: any;
  bcc: any;
  subject: any;
  templateContents: any;
  userReqFl: any;
  statusCd: any;
  templateDesc: any;
  channelCd: any;
}

interface CorrespondenceMsgDO {
  id: any,
  entityGuid: any;
  corresGuid: any;
  message: any;
  templateContents: any;
  bodyContents: any;
  body: any;

}

interface lookupObject {
  key: any, value: any
}

@Component({
  selector: 'app-correspondence-manager',
  templateUrl: './correspondence-manager.component.html',
  styleUrls: ['./correspondence-manager.component.scss']
})
export class CorrespondenceManagerComponent implements OnInit {
  _currentComponentName = 'CorrespondeceManagerComponent'

  constructor(
    private message: NzMessageService,
    private apiRequest: ApiRequestService,
    private viewContainerRef: ViewContainerRef,
    private validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private sanitizer: DomSanitizer,
    private fb: FormBuilder,
    private http: HttpClient,
    private commonUtilty: CommonUtilty,
    private appConfig: AppConfig,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private lookupDataService: LookupDataService,
    private clientService: ClientService,
    private noteService: NotesService,
    private notification: NzNotificationService,
    private interactService: InteractService,
    public appMetadataHandler: AppMetadataHandler,
    public dataTransformService : DataTransformService
  ) { }

  //Declaraions which might need developer input
  correspondenceManagerForm: FormGroup
  CORRESPONDENCEMANAGERFORM = "correspondenceManagerForm"
  selectorOfThisComponent = 'app-correspondece-manager'
  lookupsToBind = ['cor_Templates']
  parentEvent$

  @Output() componentOutput = new EventEmitter<any>();
  @Input() transactionState: any;


  corList: any;
  emailList: any;
  mobList: any;
  public _IO = null;
  @Input()
  set IO(value: any) {
    this._IO = value;
    console.log("value", value)
    this.getDoDetails();
  };


  DO: any;
  private getDoDetails() {
    if (this._IO) {
      const DOName = this.commonUtilty.getDOName(this._IO)
      if (DOName)
        this.DO = this._IO[DOName]
    }
    if (this.DO != null) {

    }
    if (this._IO) {

      this.corList = this._IO.correspondences || [];
      this.mobList = this.getClientContact();
      this.emailList = this.getClientEmail();

    }


  }

  emptycorrespondenceDO: correspondenceDO = {
    id: null,
    entityGuid: null,
    templateCd: null,
    overRideFl: null,
    receipent: null,
    cc: null,
    bcc: null,
    subject: null,
    templateContents: null,
    userReqFl: null,
    statusCd: null,
    channelCd: null,
    templateDesc: null,
  }

  emptyCorrespondenceMsgDO: CorrespondenceMsgDO = {
    id: null,
    entityGuid: null,
    corresGuid: null,
    message: null,
    templateContents: null,
    bodyContents: null,
    body: null,

  }





  get IO() {
    return this._IO;
  }

  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput)
  }
  getParentComponent(): Component {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
 } catch{}
  }
  getParentComponentName(): string {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
 } catch{}
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      this.EmitComponentOutput(null);
    })
  }

  validateOutput(o) {
    this.commonUtilty.markAllFieldDirty(o);
    return true
  }

  lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)

  ngOnInit() {
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log(`%c<${this.selectorOfThisComponent}></${this.selectorOfThisComponent}>, has been used. `, consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log(`%cExample , <${this.selectorOfThisComponent} (componentOutput)='doSomethingOnDataReceived()'></${this.selectorOfThisComponent}>`, consoleStyle)
      console.groupEnd();
    }
    if (this.IO != null) {
      if(this.commonUtilty.isArrayIterable(this.dataTransformService.workQueueResponse)){
        this.checkStage()
      }
      this.initializeNotesForm(this.IO)
      this.getDoDetails()
    }
    this.subscribeToParentEvent()
    this.correspondenceDO.channelCd = "Email"

    this.getVocabullary()

  }
  
  acknowledgementFlag = false;
  counterFl =false;
  checkStage(){
    // ****This code is commented bcz it was written for demo purpose
    // if(this.IO && this.IO.proposalDO && this.IO.proposalDO.proposalNum && this.commonUtilty.isArrayIterable(this.dataTransformService.workQueueResponse)){
    //   this.dataTransformService.workQueueResponse.forEach(item=>{
    //     if(item.proposalNum == this.IO.proposalDO.proposalNum && (item.stageCd == "PENDING_DE" || item.stageCd == "PENDING_MANUAL_UW")){
    //       this.acknowledgementFlag = true;
    //     }
    //   })
    // }

    // ****This code shows actual correspondence which get from API else will show dummy correspondence
    if(this.IO && this.IO.correspondences && this.commonUtilty.isArrayIterable(this.IO.correspondences)) 
      this.acknowledgementFlag = true;


    if(this.IO && this.IO.caseDO && this.IO.caseDO.proposalNum && this.commonUtilty.isArrayIterable(this.dataTransformService.workQueueResponse)){
      this.dataTransformService.workQueueResponse.forEach(item=>{
        if(item.proposalNum == this.IO.caseDO.proposalNum && item.stageCd == "PENDING_COUNTER_OFFER"){
          // this.corList = item;
          this.counterFl = true;
        }
        
        // else {
        //    this.acknowledgementFlag = false;
        // }
      })
    }
  }

  initializeNotesForm(data?) {
    let payload = data || {}
    this.correspondenceManagerForm = this.fb.group({

    });
    this.templateType = "select template";
  }


  getDateString(rawDate) {
    let dateString
    if (rawDate != null) {
      dateString = moment(rawDate).format(this.appMetadataHandler.GLOBAL_DATE_FORMAT_MOMENT);
    }
    else {
      dateString = 'N/A'
    }
    return dateString
  }



  correspondenceDO: correspondenceDO = this.commonUtilty.deepCopy(this.emptycorrespondenceDO);
  correspondenceMsgDO: CorrespondenceMsgDO = this.commonUtilty.deepCopy(this.emptyCorrespondenceMsgDO);
  correspondence: any[] = [];
  errorMessage: any = null;
  saveCorrespondence() {

    if (this.corsEditMode) return false;

    let validationFlag = this.validateForm()

    if (validationFlag) {
      this.correspondenceDO.entityGuid = this.DO.guid;
      this.correspondenceDO.userReqFl = true;
      this.correspondence.push(this.correspondenceDO);
      let payload = { notes: this.correspondence }
      let serviceId = this.message.loading('Saving').messageId;
      this.noteService.saveCorrespondence(this.correspondenceDO).subscribe(resp => {
        this.correspondenceMsgDO.entityGuid = this.DO.guid;
        this.correspondenceMsgDO.corresGuid
        //this.correspondenceMsgDO.message = this.correspondenceDO.templateContents;
        //this.correspondenceMsgDO.templateContents = this.correspondenceDO.templateContents;
        this.noteService.saveCorrespondenceMSG(this.correspondenceMsgDO).subscribe(res => {
          this.message.remove(serviceId);
          this.correspondenceDO.channelCd = "Email";
          this.correspondenceDO = this.commonUtilty.deepCopy(this.emptycorrespondenceDO);
          this.modalCorrespNew = false
        },
          (error) => {
            throw " Something went while saving correspondence message";
          }


        );


      },
        (error) => {
          throw " Something went wrong";
        }
      );
    }
    else {
      this.notification.error('Error Occured', this.errorMessage, { nzDuration: 2000 });
    }
  }

  verifyCorres() {

    if (this.corsEditMode) return false;
    let validationFlag = this.validateForm()
    if (validationFlag) {
      this.correspondenceDO.entityGuid = this.DO.guid;
      this.correspondenceDO.userReqFl = true;
      this.correspondence.push(this.correspondenceDO);
      let payload = { notes: this.correspondence }
      let serviceId = this.message.loading('Saving').messageId;
      this.noteService.saveCorrespondence(this.correspondenceDO).subscribe(resp => {
        this.message.success("Correspondence verified successfully");
        this.correspondenceDO = resp;
      },
        (error) => {
          throw " Something went wrong";
        }
      );
    }
    else {
      this.notification.error('Error Occured', this.errorMessage, { nzDuration: 2000 });
    }

  }


  validateForm() {
    let flag = true;
    this.errorMessage = null
    if (this.correspondenceDO.channelCd === "Email") {
      if (this.correspondenceDO.receipent == null) {
        this.errorMessage = "Please enter receipent"
        flag = false;
      }
      if (this.correspondenceMsgDO.message == null) {
        flag = false;
        this.errorMessage = "Please enter contents"
      }
      if (this.correspondenceDO.subject == null) {
        flag = false;
        this.errorMessage = "Please enter subject"
      }
    }
    else
      if (this.correspondenceDO.channelCd === "Sms") {

        if (this.correspondenceDO.receipent == null) {
          this.errorMessage = "Please enter receipent"
          flag = false;
        }
        if (this.correspondenceMsgDO.message == null) {
          flag = false;
          this.errorMessage = "Please enter contents"
        }
      }
      else {

        if (this.correspondenceMsgDO.message == null) {
          flag = false;
          this.errorMessage = "Please enter contents"
        }

      }
    return flag;
  }

  modeltemplateChange(event) {
    this.noteService.getTemplateByCode(event)
      .subscribe(resp => {
        // this.correspondenceDO.templateContents = resp.contents;
        this.correspondenceDO.templateCd = resp.templateCd;
        this.correspondenceDO.templateDesc = resp.description;
        this.correspondenceMsgDO.message = resp.contents;
        this.correspondenceMsgDO.body = resp.body;
      },
        (error) => {
          throw " Something went wrong";
        }
      );
  }

  getClienNameByGuid(clientRefGuid) {
    let filterOutput = null;
    let output = {}
    let ownerRefGuid;
    let name = null;

    let clientDO = this._IO['clientDOs'];
    if (clientDO) {
      filterOutput = clientDO.find(item => {
        if (item)
          return item['guid'] === clientRefGuid;
      }) || []
    }
    if (filterOutput != null) {

      let firstName = this.commonUtilty.getFirstNameFromClient(filterOutput)
      let lastName = this.commonUtilty.getLastNameFromClient(filterOutput);
      if (firstName == null)
        firstName = '-'
      if (lastName == null)
        lastName = '-'
      output['name'] = (firstName || "") + " " + (lastName || ""),
        output['isAvailable'] = true;
    }
    else {
      output['name'] = '-';
      output['isAvailable'] = false;
    }
    return output;
  }

  //TODO Ramesh Copy this to Product
  resetAllFields() {
    this.corsEditMode = false;
    this.correspondenceDO = this.commonUtilty.deepCopy(this.emptycorrespondenceDO);
    this.correspondenceDO.channelCd = "EMAIL"
    this.correspondenceMsgDO = this.commonUtilty.deepCopy(this.emptyCorrespondenceMsgDO);
    this.modalBtnText = "Save";
  }


  corsEditMode: boolean = false;
  // TODO Ramesh: Copy this to Product
  modalBtnText: string = "Save";
  showFooter = null;

  fetchMessageByGuid(corrsDO) {

    if (corrsDO.statusCd != "PENDING") {
      this.corsEditMode = true;
      this.modalBtnText = "Close";
      this.showFooter = null;
    } else {
      this.corsEditMode = false;
      this.modalBtnText = "Save";
      this.showFooter = true
    }
    this.noteService.getCorrMsgByGuid(corrsDO.guid).subscribe(resp => {
      this.correspondenceDO = corrsDO;
      if (resp)
        //resp.templateContents = this.sanitizer.bypassSecurityTrustHtml(resp.templateContents);
        //resp.message = this.sanitizer.bypassSecurityTrustHtml(resp.message);
        this.correspondenceMsgDO = resp;
      this.modalCorrespNew = true;
      this.modelChanged(this.correspondenceDO.channelCd);

    }
    );
  }

  cancelCorres() {
    this.modalCorrespNew = false;
  }

  modelChanged(event) {
    if (event === 'SMS') {
      this.correspondenceDO.templateContents = null
      this.correspondenceDO.receipent = null
      this.correspondenceDO.bcc = null
      this.correspondenceDO.cc = null
    }
    if (event === 'PDF') {
      this.correspondenceDO.templateContents = null
      this.correspondenceDO.receipent = null
      this.correspondenceDO.bcc = null
      this.correspondenceDO.cc = null
    }
    if (event === 'EMAIL' || event === 'LETTER') {
      this.correspondenceDO.templateContents = null
      this.correspondenceDO.receipent = null
    }
  }

  getDO(IO) {
    let output = null
    if (IO != null) {
      switch (this.transactionState) {
        case "corres": {
          if (IO['intimationDO'] || IO['claimDO']) {
            if (IO['intimationDO'])
              output = IO['intimationDO']

            if (IO['claimDO'])
              output = IO['claimDO']

            break;
          }
        }
        default: {
          console.log("Invalid choice");
          break;
        }
      }
    }

    return output
  }



  getClientEmail() {
    let tempArray = [];

    if (this._IO) {
      if (this._IO['clientDOs'] && this._IO['clientDOs'].length > 0) {
        this._IO['clientDOs'].forEach(element => {
          if (element && element.clientEmailList) {
            element.clientEmailList.forEach(element1 => {
              tempArray.push(element1.emailId);
            });
          }
        });
      }

    }

    return tempArray;
  }




  getClientContact() {
    let tempArray = [];
    if (this._IO) {
      if (this._IO['clientDOs'] && this._IO['clientDOs'].length > 0) {
        this._IO['clientDOs'].forEach(element => {
          if (element && element.clientContactDetailsList) {
            element.clientContactDetailsList.forEach(element1 => {
              tempArray.push(element1.contactNum);
            });
          }
        });
      }
    }
    return tempArray;


  }




  // static part
  // static contents later delete from here
  // replacementArray: any = [
  //   { key: "Claimant Name", value: '%claimant_name%' },
  //   { key: "Claim Number", value: '%claim_number%' },
  //   { key: "Life-Assured Name", value: '%lifeassured_name%' },
  //   { key: "Missing Documents List", value: '%missing_documents%' },
  // ];



  replacementArray = [];
  getVocabullary() {
    this.apiRequest.getCallWithAPIMapper("fetchAllVocabularies").subscribe(data => {
      this.replacementArray = data
      if (data && data.length > 0) {
        data.forEach(element => {
          let obje: lookupObject = { key: null, value: null }
          obje.key = element.vocabulary.description
          obje.value = element.vocabulary.vocabularyCd
          if (!!obje.value)
            this.replacementArray.push(obje);
        });
      }
    });
  }




  handleFileUpload(data) {
  }

  replacementSelected: any = null;
  replacementSelectedKaValue: any = null;
  replacementSelect(i) {
    this.replacementSelectedKaValue = "{_" + i + "_}";
  }

  modalCorrespNew: boolean = false;
  openCorrModal() {
    this.modalCorrespNew = true;
    this.modalBtnText = "Save";
    this.showFooter = true
  }

  //TODO Ramesh: Copy this to Product
  refreshCorrespondence() {
    console.log("Working on it");
  }

  modalPreview: boolean = false;
  previewDataStream: any = null;
  previewDataStreamUnsanitized: string = '';

  headers: HttpHeaders = new HttpHeaders({
    'Authorization': this.apiRequestService.token,
    'applicationId': environment.applicationId,
    //'hash': '7h1nk[)j',
  });

  fileFetchEndpoint: string;
  fileUploadEndpoint: string;
  fileFetchEndpointRAW: string;



  downloadInProgress = false;
  showPreview(data) {
    this.fileUploadEndpoint = this.appConfig.baseApiPath + 'cor/download';
    this.fileFetchEndpointRAW = 'cor/download';
    this.fileFetchEndpoint = this.appConfig.baseApiPath + this.fileFetchEndpointRAW;
    this.http.post<Blob>(this.fileFetchEndpoint, this.correspondenceMsgDO, {
      headers: this.headers,
      responseType: 'blob' as 'json'
    }).subscribe(res => {
      let base64data;
      if (data != 'Download') {
        let reader = new FileReader();
        reader.readAsDataURL(res);
        let me = this;
        // this.modalPreview = true;
        this.previInProgress = false;
        this.modalPDFpreview = true;
        reader.onloadend = function () {
          base64data = reader.result;
          base64data = base64data.split(',')[1];
          /* Decide Charset/Encoding */
          let charsetEncoding = 'data:application/pdf;base64';
          me.previewDataStream = me.base64ToArrayBuffer(base64data); //charsetEncoding + "," + base64data;

        }
      } else {
        this.downloadInProgress = true;
        this.downloadFile(res, "Report.pdf");
        this.downloadInProgress = false;
        this.previInProgress = false;
      }


    });


  }

  /* Emulate a download-file click */
  downloadFile(blob: any, filename: string): boolean {
    if (!filename) filename = 'file.jpg';
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    a.href = url;
    a.download = filename;
    a.click();
    return true;//url;
  }





  guessFileExtension(url) {
    let filename = this.guessFileName(url);
    return String(filename.substring(filename.indexOf(".") + 1)).toLowerCase();
  }
  guessFileName(url) {
    if (!url) return '';
    return url.substring(url.lastIndexOf('/') + 1);
  }

  guessFileType(url): string {
    let extension = url;
    if (url && url.length > 4) extension = this.guessFileExtension(url);
    /* File Type */
    if (['jpg', 'png', 'jpeg', 'jfif', 'gif', 'tiff', 'tif', 'bmp', 'webp'].includes(extension)) return "Image";
    else if (['pdf', 'doc', 'docx'].includes(extension)) return "Document";
    else if (['mp4', 'mov', 'avi', 'mpeg', 'webm'].includes(extension)) return "Video";
    else if (['mp3', 'wav', 'ogg'].includes(extension)) return "Audio";
    else if (['xls', 'xlsx', 'xlt', 'xltx', 'xlsm', 'xlsb', 'xla', 'xlam', 'xltm'].includes(extension)) return "Sheet";
    else if (['zip', 'gz', 'rar', 'rar5'].includes(extension)) return "Archive";
    else if (['eml', 'msg'].includes(extension)) return "Email";
    return "File"; // un-supported
  }

  base64ToArrayBuffer(base64) {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  templateType: any
  // templateArray = [
  //   { key: "intimation_death_sms_claimant", value: "intimation_death_sms_claimant" },
  //   { key: "intimation_death_sms_agent", value: "intimation_death_sms_agent" },
  //   { key: "intimation_death_sms_agentHierarchy", value: "intimation_death_sms_agentHierarchy" },
  //   { key: "intimation_ci_sms_claimant", value: "intimation_ci_sms_claimant" },
  //   { key: "intimation_ci_sms_agent", value: "intimation_ci_sms_agent" },
  //   { key: "intimation_ci_sms_agentHierarchy", value: "intimation_ci_sms_agentHierarchy" },
  //   { key: "reg_death_sms_claimant", value: "reg_death_sms_claimant" },
  //   { key: "reg_ci_sms_claimant", value: "reg_ci_sms_claimant" },
  //   { key: "approval_sms_claimant", value: "approval_sms_claimant" },
  //   { key: "approval_sms_agentHierarchy", value: "approval_sms_agentHierarchy" },
  //   { key: "payout_sms_claimant", value: "payout_sms_claimant" }
  // ]



  modalPDFpreview = false;
  previInProgress = false;
  showPdfPreview(type) {
    this.showPreview(type);
    this.previInProgress = true;
    //this.modalPDFpreview=true;
  }
}


